import { v4 as uuidv4 } from 'uuid'

import Toast from '@/components/toast'
import { toaster } from '@/components/ui/toaster'
import { TToastStatus } from '@/types/gigiChat/Notifications'

const useCustomToast = (onClose?: () => void) => {
    const addToast = (status: TToastStatus, message: string | React.ReactNode, duration: number | undefined = 5000, isHtml = false) => {
        const toastId = uuidv4()
        if (onClose) {
            // this is needed for announcement banner that is displayed two times on the local because
            // of react that rerender the app two times on dev environments
            toaster.remove(toastId)
        }
        return toaster.create({
            type: status,
            duration: duration,
            id: toastId,
            meta: {
                closable: true,
                render: () => <Toast message={message} status={status} onClose={closeToast} toastId={toastId} isHtml={isHtml} />,
            },
        })
    }

    const closeToast = (id: string) => {
        toaster.remove(id)
        if (onClose) {
            onClose()
        }
    }

    return [addToast, closeToast]
}

export default useCustomToast
